import React, { useState, useEffect } from 'react'
import styles from './custom_drawer.module.css'
import strings from '../../strings/strings.json'
import { useRouter } from 'next/router'
import Api from '../../../pages/api/api'


export default function CustomDrawer(props) {
    const router = useRouter()
    const [user, setUser] = useState("guest")
    useEffect(() => {
        const userInfo = Api.getInfo()
        if (userInfo !== undefined &&
            userInfo &&
            userInfo.first_name !== user) {
            setUser(userInfo)
        }
    }, [props])


    const itemHandler = (item) => {
        props.setDrawer(false)
        router.push(item)
    }


    const nameContaienr = (icon, name) => {
        return (
            <div className="flex flex_center">
                {/*   <img src={(`/assets/icons/${icon}.svg`)} alt="icon" /> */}
                <span className={styles.person}>{name}</span>
            </div>
        )
    }

    const onClickHandler = () => {
        if (user === "guest") {
            router.push('/login')
        } else {
            localStorage.clear()
            window.location.href = '/'
        }
        props.setDrawer(false)
    }

    const doClick = (address) => {
        props.setDrawer(false)
        router.push(address)
    }

    return (
        <div className={props.generalState.open ? `${styles.container} ${styles.open}` : styles.container}>
            <div className={`${styles.header_container} flex`}>
                <div className={styles.header_title_container}><span className={styles.header_title} >{strings.general_menu}</span></div>
                <div className={styles.close_img_container}><img onClick={() => props.setDrawer(false)} className={styles.close} src='/assets/icons/close.svg' alt="close" /></div>
            </div>
            <div className={styles.personContainer}>
                {nameContaienr('user', user === "guest" ? strings.general_guest : (user.first_name + ' ' + user.last_name))}
            </div>
            <div className={styles.menu_item_container}>
                <span onClick={() => itemHandler('/')} className={styles.menu_item}>{strings.general_headerHome}</span>
                <span onClick={() => itemHandler('/search')} className={styles.menu_item}>{strings.general_search}</span>
                <span onClick={() => itemHandler('/aboutApp')} className={styles.menu_item}>{strings.footer_aboutSystem}</span>
                <span onClick={() => itemHandler('/plans')} className={styles.menu_item}>{strings.general_plans}</span>
                <span className={styles.menu_item}><a className={styles.navMenu_child_txt_a} target="_blank" rel="noopener noreferrer" href="https://docs.cyberno.ir/fa/blog/faq">{strings.general_faq}</a></span>
            </div>
            <div className={styles.footer_container}>
                {user !== "guest" &&
                    <React.Fragment>
                        <div className={styles.personContainer} onClick={() => doClick('/user/dashboard')}>
                            {nameContaienr('password', strings.general_userPanel)}
                        </div>
                        <div className={styles.personContainer} onClick={() => doClick('/change-password')}>
                            {nameContaienr('password', strings.general_changePass)}
                        </div>
                    </React.Fragment>
                }
                <div className={`${styles.personContainer} ${styles.logout}`} onClick={() => onClickHandler()}>
                    {nameContaienr('user', user === "guest" ? strings.login_title_btn : strings.login_exit)}
                </div>
                <div className="flex flex_center"><img className={styles.img} src='/assets/icons/main_logo.png' alt="logo" /></div>
            </div>
        </div>
    )
}
